import script from "./ReviewMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewMapping.vue?vue&type=script&setup=true&lang=js"

import "./ReviewMapping.vue?vue&type=style&index=0&id=5b2773c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b2773c2"]])

export default __exports__